import React from 'react';

const Hero = () => {
  // Smooth scroll to invitation form section with offset for header
  const scrollToInvitation = (e) => {
    e.preventDefault();
    const element = document.getElementById('request-invitation');
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80, // 80px offset to account for fixed header
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="min-h-screen flex items-center py-5 pb-10 bg-gradient-to-br from-[#E8C4E8] via-[#F5D5C4] to-[#F9E8C4]">
      <div className="w-[90%] max-w-[1200px] mx-auto px-5">
        <div className="text-center mb-4">
          <img 
            src={require('../assets/Culture Dialogue logo 3.png')} 
            alt="Culture Dialogue Logo" 
            className="max-w-[350px] w-full h-auto mx-auto"
          />
        </div>
        <div className="max-w-[700px] text-center mx-auto opacity-0 animate-[fadeIn_1s_ease-out_forwards]">
          <h2 className="font-heading font-semibold text-[2.2rem] leading-[1.2] mb-3 text-[#1a1a2e]">
            Join the conversation that's shaping tomorrow's workplace
          </h2>
          <p className="text-[1.1rem] mb-4 text-[#333] opacity-90">
            An exclusive roundtable for senior leaders defining AI's role in their organizational future
          </p>
          <p className="text-base mb-5 text-purple font-medium">
            <strong>Mumbai | Delhi | Ahmedabad | Pune | Bangalore | Hyderabad</strong>
          </p>
          <a 
            href="#request-invitation" 
            onClick={scrollToInvitation}
            className="inline-block bg-gradient-to-br from-purple to-teal text-white font-heading font-semibold py-3 px-7 rounded-[25px] uppercase tracking-[1px] text-[0.95rem] transition-all duration-300 shadow-[0_4px_15px_rgba(107,77,196,0.4)] hover:bg-gradient-to-br hover:from-teal hover:to-purple hover:-translate-y-[3px] hover:shadow-[0_6px_25px_rgba(78,205,196,0.5)]"
          >
            Request Invitation
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;

